<template>
  <div class="body-page">
    <h6 class="fw-bold">Lista de organizações</h6>
    <div class="d-flex justify-content-end my-3">
      <Button @click="getOrganizations()" icon="pi pi-sync" class="p-button-warning p-button-sm me-2" />
      <Button @click="openModalAdd()" label="Adicionar Organização" icon="pi pi-building" class="p-button-success p-button-sm" />
    </div>

    <Table :organizations="organizations" :loading="loading" />
    <ModalAdd ref="modalAdd" />
  </div>
</template>

<script>
import Table from '@/components/pages/organizations/Table'
import Button from 'primevue/button'
import ModalAdd from '@/components/pages/organizations/ModalAdd'

export default {
  name: 'Organizations',

  components: {
    Table,
    Button,
    ModalAdd
  },

  data() {
    return {
      organizations: [],
      loading: true
    }
  },

  methods: {
    async getOrganizations() {
      this.loading = true

      await this.$api.get('/organizations')
        .then((response) => {
          this.organizations = response.data.organizations
          this.loading = false
        })
        .catch((err) => {
          this.$toastr.e(err.response.data.message, 'Erro')
        })
    },

    openModalAdd() {
      this.$refs.modalAdd.openModal()
    }
  },

  created() {
    this.getOrganizations()
  }
}
</script>

<style>
.body-page {
  width: 100%;

  padding: 20px;

  border-radius: 10px;
  border: 1px solid gainsboro;
  background: white;
}
</style>